<template>
	<div class="d-flex flex-column h-100">
		<header class="masthead mb-auto">
			<nav class="navbar navbar-expand-lg navbar-light bg-light ">
				<div class="container">
					<a class="navbar-brand" href="#">
						<img src="../../assets/img/logo-g.png" alt="Logo" />
					</a>
					<div class="my-2 my-lg-0">
						<button
							class="btn btn-primary btn-sm my-2 my-sm-0"
							@click="gotoSingin"
						>
							Login
						</button>
					</div>
				</div>
			</nav>
		</header>
		<section
			class="login-container height-auto bg-grey200 flex-shrink-0 container-fluid"
		>
			<form class="form-signin card mt-4 bg-light">
				<h5 class="text-center mb-3">Top up page</h5>
				<div class="form-group">
					<label for="exampleInputEmail1">Select network</label>
					<select
						class="custom-select form-control text-align-last"
						id="inputGroupSelect01"
					>
						<option selected>MTN</option>
						<option value="1">One</option>
						<option value="2">Two</option>
						<option value="3">Three</option>
					</select>
				</div>
				<div class="form-group">
					<label for="exampleInputEmail1">Select A BUNDLE</label>
					<select
						class="custom-select form-control text-align-last"
						id="inputGroupSelect01"
					>
						<option selected>40GB FOR 30 DAYS</option>
						<option value="1">50GB FOR 30 DAYS</option>
						<option value="2">60GB FOR 30 DAYS</option>
						<option value="3">100GB FOR 30 DAYS</option>
					</select>
				</div>
				<div class="form-group">
					<label>AMOUNT</label>
					<div class="input-group align-items-center" id="show_hide_password">
						<input
							class="form-control text-center"
							type="text"
							placeholder="₦2,000"
						/>
					</div>
				</div>
				<div class="form-group">
					<label>MOBILE NUMBER</label>
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="customRadio1"
							name="customRadio"
							class="custom-control-input"
						/>
						<label class="custom-control-label" for="customRadio1">Self</label>
					</div>
					<div class="custom-control custom-radio">
						<input
							type="radio"
							id="customRadio2"
							name="customRadio"
							class="custom-control-input"
						/>
						<label class="custom-control-label" for="customRadio2"
							>Third Party</label
						>
					</div>
				</div>
				<div class="form-group">
					<label>PHONE NUMBER</label>
					<div class="input-group">
						<div class="input-group-prepend">
							<button
								class="btn btn-light dropdown-toggle"
								type="button"
								data-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								NG (+234)
							</button>
							<div class="dropdown-menu">
								<a class="dropdown-item" href="#">select 1</a>
								<a class="dropdown-item" href="#">select 2</a>
								<a class="dropdown-item" href="#">select 1</a>
							</div>
						</div>
						<input
							type="text"
							class="form-control"
							aria-label="Text input with dropdown button"
						/>
					</div>
				</div>

				<button
					class="btn btn-primary btn-block text-uppercase mt-3"
					type="submit"
				>
					CONTINUE
				</button>
			</form>
			<p class="text-center pt-4">Download App</p>
			<p class="text-center ">
				<img src="../../assets/img/google-play.png" alt="" />
				<img src="../../assets/img/app-store.png" class="ml-2" alt="" />
			</p>
		</section>

		<footer class="footer text-dark mt-auto py-3 bg-grey200">
			<div class="container text-center">
				<a href="#nogo">Home</a>
				<a href="#nogo">Privacy Policy</a>
				<a href="#nogo">Terms of Use</a>
				<a href="#nogo">FAQ</a>
			</div>
			<div class="footer-copyright text-center py-2">
				Copyright © 2021. All Rights Reserved by IBAKA Entertainment Inc.
			</div>
		</footer>
	</div>
</template>
<style scoped>
.cursor-pointer {
	cursor: pointer;
}
</style>
<script>
export default {
	name: "TopUpPage",
	components: {},
	created() {
         this.$store.commit("showPopup", false);
		this.$store.commit("showdefaultFooter", false);
		this.$store.commit("showdefaultnav", false);
	},
	methods: {
		gotoSingin() {
			this.$router.push("/signup");
		},
		forgotpassword() {
			this.isActive = true;
			this.showforgotpasswordErr = false;

			if (this.doforgotpassword) {
				var dataToSend = {
					id: this.userid,
				};
				var self = this;
				this.$store.commit("setLoader", true);
				this.$store
					.dispatch("forgetpassword", dataToSend)
					.then((res) => {
						if (res) {
							this.$store.commit("setLoader", false);
							self.showforgotpasswordErr = true;
							self.forgotpasswordErr = res.message;
							setTimeout(function() {
								self.$router.push({ name: "login" });
							}, 10000);
						}
					})
					.catch((err) => {
						this.$store.commit("setLoader", false);
						this.showforgotpasswordErr = true;
						this.forgotpasswordErr = err.response.data.error.message;
					});
			}
		},
	},

	data() {
		return {
			showforgotpasswordErr: false,
			forgotpasswordErr: "",
			isActive: false,
			doforgotpassword: true,
			userid: "",
			password: "",
			bgImg: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
		};
	},
};
</script>
